import styled from '@emotion/styled'
import Checkbox from '@mui/material/Checkbox'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import { displayTypeAs } from 'functions'

const TableRowStyled = styled(TableRow)`
  cursor: pointer;
`

interface DefaultRowProps {
  selected: boolean
  onSelect: (id: string | number) => void
  row: Record<string, string | number>
  columns: { lookup: string; label: string; type: string }[]
  keyField: string
}

export const DefaultRow = ({
  selected = false,
  onSelect = () => null,
  row,
  columns,
  keyField,
}: DefaultRowProps) => {
  return (
    <TableRowStyled
      hover
      style={{ cursor: 'pointer' }}
      onClick={() => {
        onSelect(row[keyField] as unknown as string | number)
      }}
      role="checkbox"
      aria-checked={selected}
      tabIndex={-1}
      selected={selected}
    >
      <TableCell padding="checkbox">
        <Checkbox
          checked={selected}
          onChange={() => {
            onSelect(row[keyField] as unknown as string | number)
          }}
          inputProps={{
            'aria-labelledby': row[keyField] as string,
          }}
        />
      </TableCell>
      {columns.map(col => {
        return (
          <TableCell
            key={
              (row[keyField] as unknown as string) +
              (row[col.lookup] as unknown as string) +
              col.label
            }
            id={
              (row[keyField] as unknown as string) +
              (row[col.lookup] as unknown as string) +
              col.label
            }
          >
            {displayTypeAs(col.type, row[col.lookup])}
          </TableCell>
        )
      })}
    </TableRowStyled>
  )
}
